import { render, staticRenderFns } from "./CustomerEditTabCustomer.vue?vue&type=template&id=d6d01faa"
import script from "./CustomerEditTabCustomer.vue?vue&type=script&lang=js"
export * from "./CustomerEditTabCustomer.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditTabCustomer.vue?vue&type=style&index=0&id=d6d01faa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports